import {marked, MarkedExtension, RendererObject, Token, Tokens} from "marked";
import DOMPurify from 'dompurify';

export class MarkDown {
    // static textToHtml(text: string): string {
    //     if (text == null) {
    //         return "";
    //     }
    //     return text.replace(/\n/g, "<br>")
    // }
    //
    // static sleep = (ms) => new Promise(r => setTimeout(r, ms));

    static async parseMarkDown(text: string, sanitize: boolean = true, useExtensions: boolean = false): Promise<string> {
        // parse markdown
        // const markdown = marked.parse(text, { mangle: false, headerIds: false });

        const htmlRenderer: RendererObject = {
            // allow a hrefs 
            html({raw, text, block}) {
                // console.log("html", raw, text, block);
                return raw;
            }
        };

        const videoExtension = () : MarkedExtension => {
            let videoId = '';
            return {
                async: true,
                async walkTokens(token: Token) {
                    if (token.type !== 'text' && !token.raw.startsWith("[video") ) {
                        return;
                    }
                    if (!(token as Tokens.Text).text.startsWith("[video")) {
                        return;
                    }
                    
                    let match = token.raw.match(/\[video id=(?<id>.*?)\]/);
                    if (!match?.groups) {
                        return;
                    }
                    // console.log("videoExtension walkTokens", token, match.groups["id"]);
                    // videoId = match.groups["id"];
                    // (token as Tokens.Text).text = `<iframe id="mediaplayer" scrolling="no" frameborder="no" align="center" width="480px" height="270px" allowfullscreen="" src="https://player.babscast.com/${videoId}" lang="nl" style="width: 100%;"></iframe>`;
                    Object.assign(token, {type: "video", meta: {videoId: match.groups["id"]}});
                },
                extensions: [
                    {
                        name: "video",
                        level: "inline",
                        renderer: ( { meta, tokens = [] } ) => {
                            // console.log("videoExtension renderer");
                            return `<iframe id="mediaplayer" scrolling="no" frameborder="no" align="center" width="640x" height="360px" allowfullscreen="" src="https://player.babscast.com/${meta.videoId}" lang="nl" style="width: 100%"></iframe>`;
                        }
                    }
                ]
            }
        }
        // console.log("marked parsing", text);

        if (useExtensions) {
            marked.use(videoExtension(), {renderer: htmlRenderer});
        }

        let markdown = await marked.parse(text);
        
        // open http links in new tab
        markdown = markdown.replace(/<a href="http/g, "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"http");
        
        // return if we don't need to sanitize
        if (!sanitize) {
            return markdown;
        }

        // return a sanitized version
        return DOMPurify.sanitize(markdown);
    }
}